module.exports = __webpack_public_path__ + "static/media/linkPageIntro.905ab8be.jpg";